import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/warehouses/:warehouseId/unassign-user`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const unassignUser = {
  post: apiPathFunc(pathBase),
};
